import {DocumentDownloadIcon} from "@heroicons/react/outline";

export const customButtonIcon = () => <DocumentDownloadIcon className="h-4 w-4" aria-hidden="true" />